import type { CueScript, PrompterSettings, SessionState } from "./types";
export const defaultSettings: PrompterSettings = {
  outputWidth: 1024,
  outputHeight: 600,
  smoothScroll: true,
  highlightCurrent: true,
  fontSize: 44,
  lineHeight: 1.55,
  margin: 12,
  alignment: "center",
  direction: "auto",
  fontFamily: "Inter Variable, sans-serif",
  foreground: "#f7f3e9",
  background: "#080a0d",
  readingLine: 36,
  flipX: false,
  flipY: false,
  showGuide: true,
  guideOpacity: 0.12,
  cueOpacity: 1,
  cueLayer: "front",
  showPast: true,
  mode: "manual",
  wpm: 130,
  speedStep: 10,
  duration: 180,
  countdown: 3,
  language: "en-US",
  speechEngine: "streaming",
  streamingModel: "small",
  theme: "dark",
  layout: "studio",
  keepAwake: true,
  confidenceThreshold: 0.55,
  manualOverrideMs: 3000,
};
export const demoScript: CueScript = {
  id: "welcome",
  title: "Welcome to Cue Studio",
  tags: ["Demo"],
  notes:
    "Try pausing, changing pace, skipping a sentence, and taking over manually. This is a practice script.",
  updatedAt: Date.now(),
  html: `<h2>Make every word count.</h2><p>Welcome to <strong>Cue Studio</strong>. Your script, your pace, and a clear view of what comes next.</p><p>[Take a breath]</p><p>Start with the words. Make an important phrase <strong>bold</strong>, give a thought <em>emphasis</em>, or <u>underline a detail</u> you want to land.</p><p>Use <span style="color: #f5bb63">a warm colour</span> for a change of speaker, and <span style="color: #8fe1b5">a different colour</span> for the next idea.</p><h2>A little room to be yourself.</h2><p>When you pause, the words can wait. When you change your mind, your operator can move you back to the right line.</p><p>[Look at the camera]</p><p>Open a talent display on your Elgato, or connect a phone as a remote. Each screen follows the same word, even when the text size changes.</p><p>There is no perfect take. There is only the next good one. Let's begin.</p>`,
};
export const initialState = (
  script: CueScript = demoScript,
  settings: PrompterSettings = defaultSettings,
): SessionState => ({
  script,
  settings,
  wordIndex: 0,
  wordProgress: 0,
  playing: false,
  startedAt: null,
  elapsed: 0,
  blackout: false,
  emergency: "",
  visualCue: null,
  countdownUntil: null,
  revision: 0,
});
